<template>
    <div class="view-inner">
      <div class="page-header">
        <h1 class="page-header-title"><i class="bi bi-truck"></i> Transporte: camiones con rampa</h1>
      </div>
      <div class="camiones">
        <div  @click="$router.push('/programacion')" v-for="(camion, index) in camiones" :key="index" class="camion-card" style="cursor: pointer;">
          <table class="table">
            <thead>
              <tr>
                <th colspan="2">{{ camion.nombre }}</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>MARCA</td>
                <td>{{ camion.marca }}</td>
              </tr>
              <tr>
                <td>MODELO</td>
                <td>{{ camion.modelo }}</td>
              </tr>
              <tr>
                <td>PLACA</td>
                <td>{{ camion.placa }}</td>
              </tr>
              <tr>
                <td>PESO DE CARGA</td>
                <td>{{ camion.pesoCarga }}</td>
              </tr>
              <tr>
                <td>DIMENSIÓN DE CARGA</td>
                <td>{{ camion.dimensionCarga }}</td>
              </tr>
              <tr>
                <td>CANTIDAD DE PALLET</td>
                <td>{{ camion.cantidadPallet }}</td>
              </tr>
              <tr>
                <th colspan="2">CHOFER</th>
              </tr>
              <tr>
                <td>NOMBRE</td>
                <td>{{ camion.chofer.nombre }}</td>
              </tr>
              <tr>
                <td>DNI / CE</td>
                <td>{{ camion.chofer.dni }}</td>
              </tr>
              <tr>
                <td>LICENCIA</td>
                <td>{{ camion.chofer.licencia }}</td>
              </tr>
              <tr>
                <td>CORREO</td>
                <td>
                  <a :href="'mailto:' + camion.chofer.correo">{{ camion.chofer.correo }}</a>
                </td>
              </tr>
              <tr>
                <th colspan="2">AUXILIAR</th>
              </tr>
              <tr>
                <td>NOMBRE</td>
                <td>{{ camion.auxiliar.nombre }}</td>
              </tr>
              <tr>
                <td>DNI / CE</td>
                <td>{{ camion.auxiliar.dni }}</td>
              </tr>
              <tr>
                <td>CORREO</td>
                <td>
                  <a :href="'mailto:' + camion.auxiliar.correo">{{ camion.auxiliar.correo }}</a>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </template>
  
  <script>
  export default {
    name: 'FlotaPage',
    data() {
      return {
        camiones: [
          {
            nombre: "CAMION 01",
            marca: "KIA",
            modelo: "K2500",
            placa: "BUU-903",
            pesoCarga: "1500 KG",
            dimensionCarga: "3.30m × 1.64m × 1.90m",
            cantidadPallet: 4,
            chofer: {
              nombre: "ENRIQUE ARTURO ANDIA CORTEZ",
              dni: "40516402",
              licencia: "40516402",
              correo: "anw_operadoreslogisticos1@outlook.com"
            },
            auxiliar: {
              nombre: "JOAQUIN GABRIEL COLLANTES GOMEZ",
              dni: "60756346",
              correo: "anw_operadoreslogisticos1@outlook.com"
            }
          },
          {
            nombre: "CAMION 02",
            marca: "KIA",
            modelo: "K2700",
            placa: "ABK-891",
            pesoCarga: "1500 KG",
            dimensionCarga: "3.30m × 1.64m × 1.90m",
            cantidadPallet: 4,
            chofer: {
              nombre: "GIAN CARLOS COLLANTES BERNAL",
              dni: "10616544",
              licencia: "Q10616544",
              correo: "anw_operadoreslogisticos1@outlook.com"
            },
            auxiliar: {
              nombre: "EVANS WILLIAMS YDILFONCIO CARDENAS",
              dni: "09311935",
              correo: "anw_operadoreslogisticos1@outlook.com"
            }
          },
          {
            nombre: "CAMION 03 - EMERGENCIA LOCAL",
            marca: "HYUNDAI",
            modelo: "H100",
            placa: "C2X-789",
            pesoCarga: "1200 KG",
            dimensionCarga: "3.00m × 1.60m × 1.80m",
            cantidadPallet: 3,
            chofer: {
              nombre: "CARLOS ALBERTO MENDOZA SILVA",
              dni: "42578963",
              licencia: "A2B-42578963",
              correo: "anw_operadoreslogisticos_emergencia@outlook.com"
            },
            auxiliar: {
              nombre: "MIGUEL ANGEL TORRES RAMIREZ",
              dni: "75849632",
              correo: "anw_operadoreslogisticos_emergencia@outlook.com"
            }
          }
        ]
      };
    }
  };
  </script>
  
  <style scoped>
  .camiones {
    display: flex;
    justify-content: space-around;
    flex-wrap: wrap;
  }
  
  .camion-card {    
    padding: 10px;
    margin: 10px;
    width: 45%;
    background-color: #f9f9f9;
  }
  </style>
  